// Define component
const PackCalculator = {
    setup() {
        const { ref, onUnmounted } = Vue;
        const { useStore } = Vuex;
        
        const store = useStore();
        const packs = ref(store.getters.packsNeeded);

        // Update packs when input changes
        const updatePacks = (event) => {
            const value = Math.floor(Number(event.target.value));
            if (!isNaN(value)) {
                store.dispatch("setPacks", value);
                store.dispatch("setQuantity", value);
            }
        };

        onUnmounted(() => {
            store.dispatch("setQuantity", null);
        });

        return {
            packs,
            updatePacks
        };
    },

    template: `
        <div class="flex justify-between space-x-5">
            <div class="packs-input input-wrapper">
                <label class="input-label">Number of packs</label>
                <div class="relative">
                    <input
                        type="number"
                        min="0"
                        max="1000"
                        @input="updatePacks"
                        v-model="packs"
                        placeholder="E.g. 6"
                        class="w-full input-field noscroll"
                    />
                </div>
            </div>
        </div>
    `
};

// Export the component using module.exports
module.exports = { PackCalculator }; 